import axios from 'axios';
import {Credentials} from "./api/CredientialsService";

export const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:8080',
    withCredentials: true,
    headers: {
        'X-DEVICE': 'pa-web',
        'X-VERSION': process.env.REACT_APP_VERSION ?? 'unknown'
    },
});

export type ApiError = {
    code: string
    message: string
}

export type ServiceResponse = {
    error?: ErrorResponse
}

export type ErrorResponse = {
    apiError?: ApiError
    message: string
}

export const basicAuthHeaderForCredentials: (credentials: Credentials) => string = (credentials: Credentials) => {
    return 'Basic ' + btoa(credentials.email + ':' + credentials.password);
}

export const getApiError: (err: any) => ApiError = (err: any) => {
    if (!err || !err.response) {
        return undefined;
    }
    try {
        return err.response.data;
    } catch (e) {
        return undefined;
    }
}

export const handleApiError = (err: any): ServiceResponse => {
    let apiError: ApiError = getApiError(err);
    let errorMsg = apiError ? `${apiError.code}: ${apiError.message}` : 'Unknown error occurred.';
    console.log(errorMsg, err);
    console.log(errorMsg)
    return {
        error: {
            apiError: apiError,
            message: errorMsg
        }
    };
}
